<div class="products__simulation">
    <div class="products__simulation-container">
        <section class="products__simulation-section-hero">
            <app-hero-section [routerButton]="routerHeroButton" [logoPath]="logoPath" [isProductLogo]="isProductLogo" [buttonText]="buttonText" [header]="header" [hasBtn]="hasBtn" [imagePath]="imagePath"
                [description]="description" [joinChat]="joinChat">
            </app-hero-section>
        </section>
        <section class="products__simulation-section-hosting">
            <div class="section__hosting-header">
                <div class="section__hosting-header-title" l10nTranslate>Train your employees on</div>
                <div class="section__hosting-header-description" l10nTranslate>Realistic Phishing Simulation</div>
            </div>

            <div class="section__hosting-steps">
                <div>
                    <div class="list__steps-hosting">
                        <img src="../../../../assets/images/Eo_circle_light-blue_checkmark.svg.png">
                        <div class="list__step-hosting-text" l10nTranslate>You can launch different types of phishing:
                            links - attachments - login credentials - social engineering</div>
                    </div>
                    <div class="list__steps-hosting">
                        <img src="../../../../assets/images/Eo_circle_light-blue_checkmark.svg.png">
                        <div class="list__step-hosting-text" l10nTranslate>Support for phishing through multiple
                            channels: e-mail - text messages - WhatsApp</div>
                    </div>
                    <div class="list__steps-hosting">
                        <img src="../../../../assets/images/Eo_circle_light-blue_checkmark.svg.png">
                        <div class="list__step-hosting-text" l10nTranslate>Select the target group with high flexibility
                        </div>
                    </div>
                    <div class="list__steps-hosting">
                        <img src="../../../../assets/images/Eo_circle_light-blue_checkmark.svg.png">
                        <div class="list__step-hosting-text" l10nTranslate>Schedule simulations in advance and let the
                            platform perform them at the specified time</div>
                    </div>
                    <div class="list__steps-hosting">
                        <img src="../../../../assets/images/Eo_circle_light-blue_checkmark.svg.png">
                        <div class="list__step-hosting-text" l10nTranslate>Automatically add new employees to the
                            platform to conduct a phishing assessment on them as they begin their work</div>
                    </div>
                    <div class="list__steps-hosting">
                        <img src="../../../../assets/images/Eo_circle_light-blue_checkmark.svg.png">
                        <div class="list__step-hosting-text" l10nTranslate>Measuring employee response in real time and
                            the possibility of issuing reports for any period of time and exporting them as an Excel
                            file</div>
                    </div>
                </div>
                <div class="section__hosting-table">
                    <a href="#" l10nTranslate>Email Phishing Simulation</a>
                    <table>
                        <tr>
                            <th l10nTranslate>Delivered</th>
                            <th l10nTranslate>Opened</th>
                            <th l10nTranslate>Clicked</th>
                            <th l10nTranslate>Replied</th>
                        </tr>
                        <tr>
                            <td><img src="../../../../assets/images/tickcircle.png"></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td><img src="../../../../assets/images/tickcircle.png"></td>
                            <td><img src="../../../../assets/images/tickcircle.png"></td>
                            <td></td>
                            <td></td>


                        </tr>
                        <tr>
                            <td><img src="../../../../assets/images/tickcircle.png"></td>
                            <td><img src="../../../../assets/images/tickcircle.png"></td>
                            <td><img src="../../../../assets/images/tickcircle.png"></td>
                            <td></td>
                        </tr>
                    </table>
                </div>

            </div>

        </section>

        <section class="products-phishing__section-master-employee">
            <app-list-with-image [items]="items" [tileList]="tileSectionTwo" [descriptionList]="descriptionSectionTwo"
                [imgListPath]="employeeImgListPath" [routerListButton]="employeeRouterListButton"
                [buttonListText]="employeeButtonListText">
            </app-list-with-image>
        </section>

        <section class="products__simulation-section-reliable-support">
            <app-image-with-text [imageText]="imageText" [routerLink]="routerLink" [imageUrl]="imageUrl"
                [buttonText]="Text" [routerButton]="routerButton" [imageTextPath]="imageTextPath"
                [subImgUrl]="subImgUrl" [subTitle]="subTitle" [isProductsPage]="isProductsPage" [type]="'Products'"></app-image-with-text>
        </section>

        <section class="products__simulation-section-risk">
            <div class="section__risk-header">
                <div class="section__risk-header-title" l10nTranslate>Identify High Risk Employees Automatically</div>
                <div class="section__risk-header-description" l10nTranslate>and put assign them to a focused awareness training and further assessments
                </div>
            </div>

            <div *ngIf="currentLanguage == 'en'" class="risk__statistics">
                <img src="../../../../assets/images/Group105.png">
            </div>
            <div *ngIf="currentLanguage == 'ar'" class="risk__statistics">
                <img src="../../../../assets/images/Group105ar.png">
            </div>
        </section>

        <section class="products__simulation-section-department-perf">
            <div class="department_perf-header">
                <h2 l10nTranslate>Compare Departments Performance</h2>
                <div class="department_perf_description" l10nTranslate>Using Advanced Behavior map</div>
            </div>
            <div>
                <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/OrdersEn.png">
                <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/OrdersAr.png">
            </div>


        </section>

        <section class="products__simulation-section-response-system">
            <div class="response__system-header">
                <h2 l10nTranslate>Powerful incident response system</h2>
                <div class="response__system-description" l10nTranslate [innerHTML]="'Enhance the cyber culture of your organization and train employees to report suspicious messages And respond to it through the same platform'">
                    
                </div>
            </div>

            <div class="response__system-content">
                <div class="response__item-holder">
                    <img class="response__system-content-img" src="../../../../assets/images/outlook.png">
                    <p l10nTranslate>Outlook Reporter</p>
                </div>
                <div class="response__item-holder">
                    <img class="products-simulation__arrow" src="../../../../assets/images/Arrow 1.png">
                </div>
                <div class="response__item-holder">
                    <img class="response__system-content-img" src="../../../../assets/images/incident.png">
                    <p l10nTranslate>Incident Management</p>
                </div>
                <div class="response__item-holder">
                    <img class="products-simulation__arrow" src="../../../../assets/images/Arrow 1.png">
                </div>
                <div class="response__item-holder">
                    <img class="response__system-content-img" src="../../../../assets/images/sandboxing.png">
                    <p l10nTranslate>Sandboxing</p>
                </div>
            </div>
        </section>


        <section class="products__simulation-section-dashboard">
            <div class="dashboard__header">
                <h2 [innerHTML]="'Share Advanced Reports and Dashboards with Management'" l10nTranslate></h2>
                <div class="dashboard__description" l10nTranslate>
                    Track your program effectiveness
                </div>

            </div>
            <div class="dashboard__images-holder">
                <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/Frame 1En.png">
                <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/Frame 2En.png">
                <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/Frame 1Ar.png">
                <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/Frame 2Ar.png">
            </div>
        </section>

        <section class="products__simulation-section-feature">
            <app-feature-section>
            </app-feature-section>
        </section>

        <section class="products__simulation-section-steps">
            <h2 l10nTranslate>You Are Five Steps Away</h2>
            <p l10nTranslate>To Automate Your Awareness Program</p>
            <img *ngIf="currentLanguage == 'en'" src="../../../../assets/svg/five-step.svg" />
            <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/svg/five-step-ar.svg" />
        </section>
    </div>
</div>